import React, { useState, useEffect } from 'react';
import { Grid, Paper } from '@material-ui/core';
import { Text } from 'library';
import { useWidth } from 'reusableComponents/useWidth';
import { Colors } from '../../../constants';
import IndeedForm from './components/IndeedForm';
import IndeedNextSteps from './components/IndeedNextSteps';
import IndeedJobCard from './components/IndeedJobCard';
import { IndeedTopCardProps } from './IndeedModels';

const IndeedTopCard = ({ jobAccessor, onLoadFail, userCreated, onUserCreated }: IndeedTopCardProps) => {
    const [stylePaperLeft, setStylePaperLeft] = useState<object>({});
    const [stylePaperRight, setStylePaperRight] = useState<object>({});
    const [styleForm, setStyleForm] = useState<object>({});
    const width = useWidth();

    useEffect(() => {
        if (width === 'sm' || width === 'xs') {
            setStylePaperLeft({ borderRadius: 18 });
            setStylePaperRight({ borderRadius: 18 });
            setStyleForm({});
        } else {
            setStylePaperLeft({ borderTopLeftRadius: 18, borderBottomLeftRadius: 18 });
            setStylePaperRight({ borderTopRightRadius: 18, borderBottomRightRadius: 18 });
            setStyleForm({ paddingRight: 30 });
        }
    }, [width]);

    return (
        <Grid container>
            <Grid item md={7} xs={12} style={{ marginBottom: width === 'sm' || width === 'xs' ? 20 : 0 }}>
                <Paper
                    style={{
                        ...stylePaperLeft,
                        backgroundColor: Colors.mediumTurq,
                        width: '100%',
                        height: '100%',
                        padding: 30,
                    }}
                    elevation={4}
                >
                    <Grid container direction="column">
                        <Grid item xs={12} style={{ marginBottom: 20 }}>
                            <Text variant="h1">
                                {userCreated
                                    ? 'Your account has been created!'
                                    : "You'll now finish your application by signing up for Tandem."}
                            </Text>
                        </Grid>
                        <Grid item container direction="row">
                            <Grid item md={7} xs={12} style={styleForm}>
                                <IndeedForm userCreated={userCreated} onUserCreated={onUserCreated} />
                            </Grid>
                            <Grid item md={5} xs={12}>
                                <IndeedNextSteps />
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
            <Grid item md={5} xs={12}>
                <Paper style={{ ...stylePaperRight, width: '100%', height: '100%', padding: 30 }} elevation={4}>
                    <IndeedJobCard jobAccessor={jobAccessor} onLoadFail={onLoadFail} />
                </Paper>
            </Grid>
        </Grid>
    );
};

export default IndeedTopCard;
